import moment from 'moment';

export enum ReportStatus {
    ready = 'READY',
    new = 'NEW',
    processing = 'PROCESSING',
    error = 'ERROR'
}

export enum ReportKind {
    full = 'FULL',
    partial = 'PARTIAL'
}

export interface ReportParams {
    showAdditionalColumns: boolean;
}

export interface ReportRequestSetData {
    dateStart: moment.Moment;
    dateEnd: moment.Moment;
}
